import { useAuthStore } from '@/stores/auth.ts';

export const getPlatformComingFrom = (): string => {
	const authStore = useAuthStore();

	const url = authStore.targetUrl.split('redirect_uri=')[1] ?? 'Monizze';
	if (url.includes('merchant.')) {
		return 'login.page.platform.merchant';
	} else if (url.includes('my.')) {
		return 'login.page.platform.mm';
	} else if (url.includes('client.') || url.includes('partner.')) {
		return 'login.page.platform.ca';
	} else {
		return 'login.page.platform.default';
	}
};

/**
 * Business platforms (client, partner and merchant areas) log in with an email or phone,
 * never with a legacy card username, so the "forgot username" helper is hidden for them.
 */
export const isBusinessPlatform = (): boolean => {
	return ['login.page.platform.ca', 'login.page.platform.merchant'].includes(getPlatformComingFrom());
};
